import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-custom-number-range-filter',
  templateUrl: './custom-number-range-filter.component.html',
  styleUrls: ['./custom-number-range-filter.component.scss'],
  standalone: true,
  imports: [FormsModule, CommonModule, TableModule, ReactiveFormsModule, InputNumberModule]
})
export class CustomNumberRangeFilterComponent implements OnInit {
  @Input() field!: string;
  @Input() control!: FormControl;
  @Input() controlAlter!: FormControl;

  @Output() onChangeNumberRangeFilter = new EventEmitter<{ propertyName: string, valueFilter: any, valueAlterFilter: any }>();

  startNumber: number | null = null;
  endNumber: number | null = null;

  constructor(private toastHandlerService: ToastHandlerService,) { }

  ngOnInit() {
  }

  filterInput(event: Event) {

    const inputElement = event.target as HTMLInputElement;
    const value = Number(inputElement.value);

    if (isNaN(value)) {
      this.toastHandlerService.showToast('error', 'El valor ingresado no es un número válido.');
      return;
    }

    if (value === 0) return;

    if (inputElement.id === 'start') {
      this.startNumber = value;
      if (this.endNumber === null || this.endNumber < this.startNumber) {
        this.endNumber = this.startNumber;
      }
    } else if (inputElement.id === 'end') {
      this.endNumber = this.endNumber! < this.startNumber! ? this.startNumber : value;
    }

    if (this.startNumber !== null && this.endNumber !== null && this.startNumber <= this.endNumber) {
      this.onChangeNumberRangeFilter.emit({
        propertyName: this.field,
        valueFilter: this.startNumber,
        valueAlterFilter: this.endNumber
      });
    }

  }
}
